export const defaultLayout = (LayoutAccountID) => ({
    "LayoutID": 1,
    "LayoutName": "Default Layout",
    "LayoutStatusID": 1,
    "LayoutAccountID": LayoutAccountID,
    "LayoutStatusName": "Enable",
    "LayoutParametersList": [
        {
            "JPath": "$ShowWidgetTitles",
            "Value": "1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 1,
            "ParameterTypeName": "Boolean",
            "LayoutParameterName": "ShowWidgetTitles",
            "LayoutParameterValueID": 603
        },
        {
            "JPath": "$FontSize",
            "Value": "16",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 2,
            "ParameterTypeName": "Number",
            "LayoutParameterName": "FontSize",
            "LayoutParameterValueID": 604
        },
        {
            "JPath": "$WidgetTitlesFontSize",
            "Value": "22",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 3,
            "ParameterTypeName": "Number",
            "LayoutParameterName": "WidgetTitlesFontSize",
            "LayoutParameterValueID": 605
        },
        {
            "JPath": "$WidgetGroupTitlesFontSize",
            "Value": "48",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 20,
            "ParameterTypeName": "Number",
            "LayoutParameterName": "WidgetGroupTitlesFontSize",
            "LayoutParameterValueID": 606
        },
        {
            "JPath": "$MinRefreshInterval",
            "Value": "1000",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 21,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "MinRefreshInterval",
            "LayoutParameterValueID": 607
        },
        {
            "JPath": "$RefreshRealTimeDataDelay",
            "Value": "30",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 22,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "RefreshRealTimeDataDelay",
            "LayoutParameterValueID": 608
        },
        {
            "JPath": "$ReportInterval",
            "Value": "180",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 23,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "ReportInterval",
            "LayoutParameterValueID": 609
        },
        {
            "JPath": "$ReportSwitching",
            "Value": "0",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 24,
            "ParameterTypeName": "Boolean",
            "LayoutParameterName": "ReportSwitching",
            "LayoutParameterValueID": 610
        },
        {
            "JPath": "$ReportRefresh",
            "Value": "0",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 25,
            "ParameterTypeName": "Boolean",
            "LayoutParameterName": "ReportRefresh",
            "LayoutParameterValueID": 611
        },
        {
            "JPath": "$ColorPrimary",
            "Value": "#3280C1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 26,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorPrimary",
            "LayoutParameterValueID": 612
        },
        {
            "JPath": "$ColorBackground",
            "Value": "#FFFFFF",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 27,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorBackground",
            "LayoutParameterValueID": 613
        },
        {
            "JPath": "$ColorFrames",
            "Value": "#edf2f7",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 28,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorFrames",
            "LayoutParameterValueID": 614
        },
        {
            "JPath": "$ColorWidgetGroupBackground",
            "Value": "#edf2f7",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 29,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorWidgetGroupBackground",
            "LayoutParameterValueID": 615
        },
        {
            "JPath": "$ColorWidgetGroupFrames",
            "Value": "#edf2f7",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 30,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorWidgetGroupFrames",
            "LayoutParameterValueID": 616
        },
        {
            "JPath": "$ColorWidgetGroupTitles",
            "Value": "#000000",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 31,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorWidgetGroupTitles",
            "LayoutParameterValueID": 617
        },
        {
            "JPath": "$ActoveCallWarning",
            "Value": "1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 33,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "ActiveCallWarning",
            "LayoutParameterValueID": 6770
        },
        {
            "JPath": "$ActiveCallLimit",
            "Value": "1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 34,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "ActiveCallLimit",
            "LayoutParameterValueID": 6767
        },
        {
            "JPath": "$ActiveCallWarningColor",
            "Value": "",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 35,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ActiveCallWarningColor",
            "LayoutParameterValueID": 6782
        },
        {
            "JPath": "$ActiveCallLimitColor",
            "Value": "",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 36,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ActiveCallLimitColor",
            "LayoutParameterValueID": 6779
        },
        {
            "JPath": "$HoldTimeWarning",
            "Value": "1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 37,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "HoldTimeWarning",
            "LayoutParameterValueID": 7350
        },
        {
            "JPath": "$HoldTimeLimit",
            "Value": "1",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 38,
            "ParameterTypeName": "Interval",
            "LayoutParameterName": "HoldTimeLimit",
            "LayoutParameterValueID": 6761
        },
        {
            "JPath": "$HoldTimeWarningColor",
            "Value": "",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 39,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "HoldTimeWarningColor",
            "LayoutParameterValueID": 6776
        },
        {
            "JPath": "$HoldTimeLimitColor",
            "Value": "",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 40,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "HoldTimeLimitColor",
            "LayoutParameterValueID": 6773
        },
        {
            "JPath": "$WidgetTableContentFontSize",
            "Value": "16",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 41,
            "ParameterTypeName": "Number",
            "LayoutParameterName": "WidgetTableContentFontSize",
            "LayoutParameterValueID": 1120571
        },
        {
            "JPath": "$LoginStatusWarningColor",
            "Value": "#FAB11E",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 42,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "LoginStatusWarningColor",
            "LayoutParameterValueID": 1122806
        },
        {
            "JPath": "$LoginStatusLimitColor",
            "Value": "#FF3636",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 43,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "LoginStatusLimitColor",
            "LayoutParameterValueID": 1122809
        },
        {
            "JPath": "$InCallColor",
            "Value": "#5EB300",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 44,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "InCallColor",
            "LayoutParameterValueID": 1123385
        },
        {
            "JPath": "$OnHoldColor",
            "Value": "#E53E3E",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 45,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "OnHoldColor",
            "LayoutParameterValueID": 1123388
        },
        {
            "JPath": "$.MainBgColor",
            "Value": "#FFFFFF",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 46,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "MainBgColor",
            "LayoutParameterValueID": 1124812
        },
        {
            "JPath": "$.SecondaryBgColor",
            "Value": "#FFFFFF",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 47,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "SecondaryBgColor",
            "LayoutParameterValueID": 1124788
        },
        {
            "JPath": "$.ItemsMainColor",
            "Value": "#f5f7fa",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 48,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ItemsMainColor",
            "LayoutParameterValueID": 1124785
        },
        {
            "JPath": "$.ItemsSecondaryColor",
            "Value": "#f5f7fa",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 49,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ItemsSecondaryColor",
            "LayoutParameterValueID": 1124809
        },
        {
            "JPath": "$.CardsBgColor",
            "Value": "#f5f7fa",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 50,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "CardsBgColor",
            "LayoutParameterValueID": 1124797
        },
        {
            "JPath": "$.MainTextColor",
            "Value": "#000000",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 51,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "MainTextColor",
            "LayoutParameterValueID": 1124794
        },
        {
            "JPath": "$.ColorWidgetHeaderText",
            "Value": "#899398",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 52,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorWidgetHeaderText",
            "LayoutParameterValueID": 1124791
        },
        {
            "JPath": "$.ColorWidgetBackground",
            "Value": "#f7fafc",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 53,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorWidgetBackground",
            "LayoutParameterValueID": 1124806
        },
        {
            "JPath": "$.WidgetBorderColor",
            "Value": "#BEC2C9",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 65,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "WidgetBorderColor",
            "LayoutParameterValueID": 1129250
        },
        {
            "JPath": "$.ColorTableHeaderBg",
            "Value": "#FFFFFF",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 54,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorTableHeaderBg",
            "LayoutParameterValueID": 1124800
        },
        {
            "JPath": "$.ColorTableContentText",
            "Value": "#000000",
            "IsText": 0,
            "ValueText": "",
            "LayoutParameterID": 55,
            "ParameterTypeName": "Color",
            "LayoutParameterName": "ColorTableContentText",
            "LayoutParameterValueID": 1124803
        },{
            "IsText": 0,
            "JPath": "$.SoundWarning",
            "LayoutParameterID": 57,
            "LayoutParameterName": "SoundWarning",
            "LayoutParameterValueID": 1128998,
            "ParameterTypeName": "SingleSoundSelector",
            "Value": "none",
            "ValueText": ""
        },{
            "IsText": 0,
            "JPath": "$.SoundError",
            "LayoutParameterID": 58,
            "LayoutParameterName": "SoundError",
            "LayoutParameterValueID": 1129001,
            "ParameterTypeName": "SingleSoundSelector",
            "Value": "none",
            "ValueText": ""
        }
    ]
})

export const extensionThresholdKeys = [
    'ActiveCallWarningColor',
    'ActiveCallLimitColor',
    'HoldTimeWarningColor',
    'HoldTimeLimitColor',
    'ActiveCallWarning',
    'ActiveCallLimit',
    'HoldTimeWarning',
    'HoldTimeLimit',
]

export const defaultExtensionThresholdConfig = {
    'ActiveCallWarningColor': 'green',
    'ActiveCallLimitColor': 'red',
    'HoldTimeWarningColor': 'green',
    'HoldTimeLimitColor': 'red',
    'ActiveCallWarning': 1,
    'ActiveCallLimit': 1,
    'HoldTimeWarning': 1,
    'HoldTimeLimit': 1,
}
